module.exports = __webpack_public_path__ + "assets/0972f21af3e75388ef55435c0b3b831d.js";